module.exports = __webpack_public_path__ + "static/media/investpic3@3x.71e571b0.png";